import type { GameManifest } from "../../contracts/game";

/**
 * The public CRAM game is the momentum build: a longer run-up before contact.
 * The rejected compact profile remains in source history but is not a public
 * launcher entry.
 */
export const momentumTrackManifest: GameManifest = {
  id: "momentum-track",
  title: "CRAM!",
  version: "1.0.0",
  status: "playable",
  coverAsset: "/covers/cram.jpg",
  catalogOrder: 0,
  supportsCpu: false,
  load: async () => {
    const module = await import("./index");
    return { create: (context) => module.createWithVariant(context, "momentum") };
  },
};
